import React, { type JSX } from 'react';
import { ExternalLinkIconSvg } from '@resources/js/components/ExternalLinkIconSvg/ExternalLinkIconSvg';
import LinkButton from '@resources/js/components/LinkButton/LinkButton';
import useTheme from '@resources/js/contexts/useTheme';

type Props = {
  className?: string;
  caption: string;
  text: string;
  href?: string;
  onClick?: () => void;
  isExternal?: boolean;
  backgroundImageUrl?: string | null;
};

export const BuildsLargeLinkButton = ({
  className = '',
  caption,
  text,
  href,
  onClick,
  isExternal,
  backgroundImageUrl = null,
}: Props): JSX.Element => {
  const theme = useTheme();

  return (
    <LinkButton
      styles={theme.primaryButtonStyles}
      href={href}
      onClick={onClick}
      openInNewTab={isExternal}
      className={'builds-large-link-button ' + className}
    >
      {backgroundImageUrl ? (
        <div
          className={'builds-large-link-button__background-icon'}
          style={{
            backgroundImage: `url(${backgroundImageUrl})`,
          }}
        ></div>
      ) : null}
      <div className={'builds-large-link-button__caption'}>{caption}</div>
      <div className={'builds-large-link-button__text'}>
        {text}
        {isExternal ? <ExternalLinkIconSvg /> : null}
      </div>
    </LinkButton>
  );
};
